module.exports = __webpack_public_path__ + "static/media/eva_person-add-outline.55c6a9c5.svg";